var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M169.093 61.233C166.259 61.5896 163.443 62.0277 160.631 62.5723C97.114 74.6768 35.7564 131.005 45.349 198.903C52.7657 251.046 93.5708 296.952 144.581 309.84C225.772 330.384 319.218 260.977 332.83 180.343C335.32 165.48 334.939 149.695 328.723 135.949C324.68 127.666 319.313 120.1 312.833 113.548C276.71 74.9225 221.513 54.2959 169.093 61.233Z","fill":"currentColor"}));
}

Circle.defaultProps = {"viewBox":"0 0 369 369","fill":"none"};

module.exports = Circle;

Circle.default = Circle;
